<template>
  <section
    class="relative overflow-hidden bg-gray-100 pt-28 pb-28 mb-12 md:mb-14"
  >
    <SectionWaves />
    <div
      class="relative z-10 container mx-auto max-w-[1200px] px-4 py-12 md:py-16"
    >
      <h2 class="landing_h2 mb-4 text-center">
        <Translate translate-key="selling_tradelines_page.subtitle" />
      </h2>
      <div
        class="prose prose-gray max-w-none text-left prose-p:mb-3 prose-ul:my-3 prose-li:my-0.5 prose-a:text-success prose-a:underline hover:prose-a:no-underline"
      >
        <NuxtImg
          src="/boost/sell-your-credit-as-a-tradeline.png"
          :alt="t('selling_tradelines_page.alt')"
          width="450"
          height="285"
          format="webp"
          class="float-none w-full sm:float-right sm:ml-6 sm:mb-4 sm:w-[450px] sm:max-w-[45%] rounded-lg object-cover"
        />
        <div
          class="prose prose-gray max-w-none text-gray-700 prose-p:mb-3 prose-ul:my-3 prose-ul:list-disc prose-ul:pl-5 prose-li:my-0.5 prose-a:text-success prose-a:underline hover:prose-a:no-underline prose-strong:font-semibold"
          v-html="t('selling_tradelines_page.text_content')"
        />
        <div class="clear-both" />
        <div class="flex justify-center pt-6">
          <Button
            v-if="!currentUserStore.isAuthenticated"
            id="getStartedSellingTradelines"
            as="a"
            :href="linkHref('/signup?type=cardholder')"
            variant="landing1"
            size="xl"
          >
            <Translate
              translate-key="selling_tradelines_page.get_started_now"
            />
          </Button>
          <Button
            v-else-if="!currentUserStore.isCardholder"
            id="getStartedSellingTradelines"
            as="a"
            :href="linkHref('/#contact')"
            variant="landing1"
            size="xl"
          >
            <Translate
              translate-key="selling_tradelines_page.get_started_now"
            />
          </Button>
          <a
            v-else
            id="getStartedSellingTradelines"
            :href="linkHref('/cardholder')"
            class="inline-block rounded-lg bg-landing-primary px-8 py-4 font-semibold text-white hover:bg-landing-primary-hover"
          >
            <Translate translate-key="services_common_home.start_selling" />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import SectionWaves from "~/features/landing-page/components/sections/SectionWaves.vue";
import Translate from "~/shared/components/i18n/Translate/Translate.vue";
import { Button } from "~/shared/components/ui/button";
import { useI18n } from "vue-i18n";
import { useCurrentUserStore } from "~/stores/userStore";

const { linkHref } = useNativeRouteLink();
const { t } = useI18n();
const currentUserStore = useCurrentUserStore();
</script>
